// const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const getApiRole = (uiRole) => {
//   const roleMapping = {
//     SuperAdmin: "superadmin",
//     Finance: "finance",
//     Ops: "ops",
//     Support: "support",
//   };
//   return roleMapping[uiRole] || "ops";
// };

// const makeRequest = async (endpoint, options = {}) => {
//   const token = localStorage.getItem("authToken");
//   if (!token) {
//     throw new Error("No authentication token found. Please login first.");
//   }

//   const controller = new AbortController();
//   const timeoutId = setTimeout(() => controller.abort(), 12000);

//   try {
//     const response = await fetch(`${BASE_URL}${endpoint}`, {
//       method: options.method || "GET",
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//         ...options.headers,
//       },
//       body: options.body,
//       signal: controller.signal,
//     });

//     if (!response.ok) {
//       const errorText = await response.text();
//       let errorMessage = errorText || "Unknown API error";
//       try {
//         const parsed = JSON.parse(errorText);
//         errorMessage = parsed?.msg?.error || parsed?.msg?.status || errorText;
//       } catch {
//         // keep text response
//       }
//       throw new Error(`API Error ${response.status}: ${errorMessage}`);
//     }

//     return response.json();
//   } catch (error) {
//     if (error.name === "AbortError") {
//       throw new Error("Request timeout. Please try again.");
//     }
//     throw error;
//   } finally {
//     clearTimeout(timeoutId);
//   }
// };

// export const getHospitalsList = async (role, params = {}) => {
//   const apiRole = getApiRole(role);
//   const queryParams = new URLSearchParams();

//   queryParams.append("page", String(params.page || 1));
//   queryParams.append("items", String(params.items || 20));

//   const filters = [];
//   if (params.city?.trim()) filters.push({ key: "city", value: params.city.trim() });
//   if (params.name?.trim()) filters.push({ key: "name", value: params.name.trim() });
//   if (params.state?.trim()) filters.push({ key: "state", value: params.state.trim() });

//   if (filters.length > 0) {
//     queryParams.append("filters", JSON.stringify(filters));
//   }

//   return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/list/?${queryParams.toString()}`);
// };

// export const createHospital = async (role, payload) => {
//   const apiRole = getApiRole(role);
//   return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/create/`, {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });
// };

// export const getHospitalDetail = async (role, hospitalId) => {
//   const apiRole = getApiRole(role);
//   const endpointCandidates = [
//     `/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/detail/`,
//     `/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/`,
//   ];

//   let lastError = null;
//   for (const endpoint of endpointCandidates) {
//     try {
//       return await makeRequest(endpoint);
//     } catch (error) {
//       lastError = error;
//     }
//   }

//   throw lastError || new Error("Unable to fetch hospital detail.");
// };


import { parseApiError } from '../utils/apiErrorParser';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Internal pincode lookup service (replaces the public India Post API).
// Base host can be overridden per-environment; falls back to the dev backend.


/**
 * Look up locality / city / state options for a 6-digit pincode.
 * Returns the `msg` payload: { pincode, locations: [{ city, district, state, ... }] }
 * where `city` is the locality (post-office) name and `district` is the city.
 */
export const lookupPincodeDetail = async (pincode) => {
  if (!/^\d{6}$/.test(pincode)) return null;
  const headers = {};
  const apiKey = process.env.REACT_APP_WEBAPI_KEY;
  if (apiKey) headers["X-API-KEY"] = apiKey;

  const response = await fetch(
    `${BASE_URL}/v3/apis/webapi/v4/pincode/detail/?pincode=${pincode}`,
    { headers }
  );
  if (!response.ok) throw new Error("Pincode lookup failed");
  const data = await response.json();
  return data?.msg || null;
};

const getApiRole = (uiRole) => {
  const roleMapping = {
    SuperAdmin: "superadmin",
    Finance: "finance",
    Ops: "ops",
    Support: "support",
  };
  return roleMapping[uiRole] || "ops";
};

const makeRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem("authToken");
  if (!token) {
    throw new Error("No authentication token found. Please login first.");
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 12000);

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: options.method || "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        ...options.headers,
      },
      body: options.body,
      signal: controller.signal,
    });

    if (!response.ok) {
      const errorText = await response.text();
      let message = '';
      try {
        message = parseApiError(JSON.parse(errorText));
      } catch {
        message = errorText || `Request failed (${response.status})`;
      }
      throw new Error(message);
    }

    return response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      throw new Error("Request timeout. Please try again.");
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};

export const getHospitalsList = async (role, params = {}) => {
  const apiRole = getApiRole(role);
  const queryParams = new URLSearchParams();

  queryParams.append("page", String(params.page || 1));
  queryParams.append("items", String(params.items || 20));

  const filters = [];

  if (params.city?.trim()) {
    filters.push({ key: "city", value: params.city.trim() });
  }

  if (params.name?.trim()) {
    filters.push({ key: "name", value: params.name.trim() });
  }

  if (params.state?.trim()) {
    filters.push({ key: "state", value: params.state.trim() });
  }

  if (filters.length > 0) {
    queryParams.append("filters", JSON.stringify(filters));
  }

  return makeRequest(
    `/internal/apis/v4/${apiRole}/hospitals/list/?${queryParams.toString()}`
  );
};

export const createHospital = async (role, payload) => {
  const apiRole = getApiRole(role);

  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/create/`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const getHospitalDetail = async (role, hospitalId) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/detail/`);
};

export const editHospital = async (role, hospitalId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/edit/`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
};

export const getHospitalContacts = async (role, hospitalId) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/contacts/list/`);
};

export const editHospitalContact = async (role, hospitalId, contactId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/contacts/${contactId}/edit/`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
};

export const createHospitalContact = async (role, hospitalId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/contacts/create/`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const getHospitalDocuments = async (role, hospitalId) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/documents/list/`);
};

export const getHospitalBank = async (role, hospitalId) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/bank/detail/`);
};

export const editHospitalBank = async (role, hospitalId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/bank/edit/`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
};

export const saveHospitalBank = async (role, hospitalId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/bank/create/`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const getContractSigningAuthority = async (role, hospitalId) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/contract-signing-authority/detail/`);
};

export const saveContractSigningAuthority = async (role, hospitalId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/contract-signing-authority/save/`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const getTreatmentPackages = async (role, hospitalId, params = {}) => {
  const apiRole = getApiRole(role);
  const queryParams = new URLSearchParams();
  queryParams.append("page", String(params.page || 1));
  queryParams.append("items", String(params.items || 10));
  if (params.name) {
    queryParams.append("filters", JSON.stringify([{ key: "name", value: params.name }]));
  }
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/treatment-packages/list/?${queryParams.toString()}`);
};

export const createTreatmentPackage = async (role, hospitalId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/treatment-packages/create/`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const editHospitalRoom = async (role, hospitalId, roomId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/rooms/${roomId}/edit/`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
};

export const createHospitalRoom = async (role, hospitalId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/rooms/create/`, {
    method: "POST",
    body: JSON.stringify(payload), // { name, room_type: "general"|"private"|"deluxe"|"suite", base_price }
  });
};

export const addCustomRoom = async (role, hospitalId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/rooms/add-custom-room/`, {
    method: "POST",
    body: JSON.stringify(payload), // { name, base_price }
  });
};

export const getHospitalRooms = async (role, hospitalId) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/rooms/list/`);
};

export const editPackageRoomPrice = async (role, hospitalId, packageId, roomId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(
    `/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/treatment-packages/${packageId}/rooms/${roomId}/edit-price/`,
    { method: "PATCH", body: JSON.stringify(payload) }
  );
};

export const addRoomPriceToPackage = async (role, hospitalId, packageId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/treatment-packages/${packageId}/add-room-price/`, {
    method: "POST",
    body: JSON.stringify(payload), // { room: uuid, price }
  });
};

export const getTreatmentPackageDetail = async (role, hospitalId, packageId) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/treatment-packages/${packageId}/detail/`);
};

export const updateTreatmentPackage = async (role, hospitalId, packageId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/treatment-packages/${packageId}/update/`, {
    method: "POST",
    body: JSON.stringify(payload), // { inclusion, duration_in_day }
  });
};

export const getFinancialConfig = async (role, hospitalId) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/financial-config/detail/`);
};

export const saveFinancialConfig = async (role, hospitalId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/financial-config/create/`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const editFinancialConfig = async (role, hospitalId, payload) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/financial-config/edit/`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
};

export const downloadHospitalTemplate = async (role) => {
  const apiRole = getApiRole(role);
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("No authentication token found. Please login first.");

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 15000);

  try {
    const response = await fetch(
      `${BASE_URL}/internal/apis/v4/${apiRole}/hospitals/download-template/?_=${Date.now()}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        signal: controller.signal,
      }
    );
    if (!response.ok) {
      const text = await response.text();
      let msg = text;
      try { msg = JSON.parse(text)?.msg?.error || msg; } catch { }
      throw new Error(`API Error ${response.status}: ${msg}`);
    }
    return response.blob();
  } catch (error) {
    if (error.name === "AbortError") throw new Error("Request timeout. Please try again.");
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};

// Enqueue an async bulk-upload job. Returns { job_id, total_rows, status } in `msg`.
// Processing happens in Celery; poll getHospitalBulkUploadStatus for progress.
export const bulkUploadHospitals = async (role, file) => {
  const apiRole = getApiRole(role);
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("No authentication token found. Please login first.");

  const formData = new FormData();
  formData.append("file", file);

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 30000);

  try {
    const response = await fetch(
      `${BASE_URL}/internal/apis/v4/${apiRole}/hospitals/bulk-upload/`,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
        signal: controller.signal,
      }
    );
    if (!response.ok) {
      const text = await response.text();
      let msg = text;
      try { msg = JSON.parse(text)?.msg?.error || msg; } catch { }
      throw new Error(msg);
    }
    return response.json();
  } catch (error) {
    if (error.name === "AbortError") throw new Error("Request timeout. Please try again.");
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};

// Poll the job status. Returns the full status payload in `msg`.
export const getHospitalBulkUploadStatus = async (role, jobId) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/hospitals/bulk-upload/${jobId}/`);
};

export const editHospitalDocument = async (role, hospitalId, documentId, file) => {
  const apiRole = getApiRole(role);
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("No authentication token found. Please login first.");

  const formData = new FormData();
  formData.append("file", file);

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 30000);

  try {
    const response = await fetch(
      `${BASE_URL}/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/documents/${documentId}/edit/`,
      {
        method: "PATCH",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
        signal: controller.signal,
      }
    );
    if (!response.ok) {
      const text = await response.text();
      let msg = text;
      try { msg = JSON.parse(text)?.msg?.error || msg; } catch { }
      throw new Error(`API Error ${response.status}: ${msg}`);
    }
    return response.json();
  } catch (error) {
    if (error.name === "AbortError") throw new Error("Request timeout. Please try again.");
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};

export const uploadHospitalDocument = async (role, hospitalId, file, labelName) => {
  const apiRole = getApiRole(role);
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("No authentication token found. Please login first.");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("label_name", labelName);

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 30000);

  try {
    const response = await fetch(
      `${BASE_URL}/internal/apis/v4/${apiRole}/hospitals/${hospitalId}/documents/upload/`,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
        signal: controller.signal,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      let errorMessage = errorText || "Unknown API error";
      try {
        const parsed = JSON.parse(errorText);
        errorMessage = parsed?.msg?.error || parsed?.msg?.status || errorText;
      } catch {
        // keep raw text
      }
      throw new Error(`API Error ${response.status}: ${errorMessage}`);
    }

    return response.json();
  } catch (error) {
    if (error.name === "AbortError") throw new Error("Request timeout. Please try again.");
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};